import { OAuthRedirect } from './OAuthRedirect';
import DeelOauthCallback from '../SignIn/Deel/DeelOauthCallback';
import FactorialHROauthCallback from '../SignIn/FactorialHR/FactorialHROAuthCallback';
import { PaycorOauthCallback } from '../SignIn/Paycor/PaycorOAuthCallback';
import { RipplingOauthCallback } from '../SignIn/Rippling/RipplingOauthCallback';
import BambooHrOauthCallback from '../SignIn/BambooHR/BambooHrOAuthCallback';
import LatticeOauthCallback from '../SignIn/Lattice/LatticeOauthCallback';
import { GustoOauthCallback } from '../SignIn/Gusto/GustoOAuthCallback';
import RemoteOAuthCallback from '../SignIn/Remote/RemoteOAuthCallback';
import BobOAuthCallback from '../SignIn/Bob/BobOAuthCallback';
import PaylocityOAuthCallback from '../SignIn/Paylocity/PaylocityOAuthCallback';
import EveryOAuthCallback from '../SignIn/Every/EveryOAuthCallback';

export const customOauthCallbackRoutes = [
  {
    path: '/auth/deel',
    component: DeelOauthCallback,
  },
  {
    path: '/auth/gusto',
    component: GustoOauthCallback,
  },
  {
    path: '/auth/justworks',
    component: OAuthRedirect,
  },
  {
    path: '/auth/bamboo_hr',
    component: BambooHrOauthCallback,
  },
  {
    path: '/auth/oyster_hr',
    component: OAuthRedirect,
  },
  {
    path: '/auth/square_payroll',
    component: OAuthRedirect,
  },
  {
    path: '/auth/paycor',
    component: PaycorOauthCallback,
  },
  {
    path: '/auth/factorial_hr',
    component: FactorialHROauthCallback,
  },
  {
    path: '/auth/rippling',
    component: RipplingOauthCallback,
  },
  {
    path: '/auth/lattice',
    component: LatticeOauthCallback,
  },
  {
    path: '/auth/remote',
    component: RemoteOAuthCallback,
  },
  {
    path: '/auth/bob',
    component: BobOAuthCallback,
  },
  {
    path: '/auth/paylocity',
    component: PaylocityOAuthCallback,
  },
  {
    path: '/auth/every_io',
    component: EveryOAuthCallback,
  },
];
